/**
 * createSwitchChampionController — Swap player kit + mesh from roster key (P3-22).
 */
import { createChampion } from '../../domain/champions.js';
import { ChampionMeshFactory } from '../factory/championMeshFactory.js';

const KIT_EXTRA_KEYS = [
  'qEmpowered',
  'wActive',
  'wEmpowered',
  'damageReduction',
  'tenacity',
  'isSpinning',
  'spinTimer',
  'applyEmpoweredQ',
  'moltenShieldActive',
  'ricochetActive',
  'ricochetCharges',
  'hemorrhageStacks',
  'grit',
  'counterStrikeActive',
  'grandmasterActive',
  'spellShieldActive',
  'onTheHuntActive',
  'prismaticBarrierActive',
  'shieldHp'
];

export function createSwitchChampionController({
  championEntity,
  championGroup,
  getMesh,
  setMesh,
  dom,
  hudUI
}) {
  return function switchChampion(sel) {
    const key = String(sel || '').toLowerCase();
    const t = createChampion(
      key,
      championEntity.id,
      championEntity.team,
      championEntity.x,
      championEntity.z
    );
    if (!t) return;
    Object.assign(championEntity, {
      name: t.name,
      maxHp: t.maxHp,
      hp: t.maxHp,
      maxMp: t.maxMp,
      mp: t.maxMp,
      ad: t.ad,
      ap: t.ap || 0,
      armor: t.armor,
      mr: t.mr,
      ms: t.ms,
      as: t.as ?? t.attackSpeed,
      attackRange: t.attackRange,
      championKey: key
    });
    for (const extra of KIT_EXTRA_KEYS) {
      if (Object.prototype.hasOwnProperty.call(t, extra)
        || typeof t[extra] === 'function') {
        championEntity[extra] = t[extra];
      }
    }
    const prev = getMesh();
    if (prev) championGroup.remove(prev);
    const next = ChampionMeshFactory.createChampionMesh(key, 'blue');
    setMesh(next);
    championGroup.add(next);
    if (dom.playerNamePlate) {
      dom.playerNamePlate.textContent = `${championEntity.name} (Blue)`;
    }
    hudUI.applyHpTicks(dom.playerHpBox, championEntity.maxHp, 50);
  };
}
